module.exports = __webpack_public_path__ + "img/emoji_piscar.dc29522e.png";